import { type TUploadFileForm } from '@core/api'

export const uploadFile = ({ file, policy, onProgress, signal }: TUploadFileForm) => {
    const { fields = {}, field = 'file', url, method } = policy

    const isPut = method === 'PUT'
    const isPost = method === 'POST'

    const dataToSend = isPost ? new FormData() : file

    if (isPost && dataToSend instanceof FormData) {
        Object.keys(fields).forEach(key => {
            dataToSend.append(key, fields[key])
        })
        dataToSend.append(field, file)
    }

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()

        xhr.upload.addEventListener('progress', event => {
            if (onProgress && event.lengthComputable) {
                onProgress(event.loaded / event.total)
            }
        })

        xhr.addEventListener('load', () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response)
            } else {
                reject(new Error(`Error: ${xhr.status} ${xhr.statusText}`))
            }
        })

        xhr.addEventListener('error', () => {
            reject(new Error('Network Error'))
        })

        xhr.addEventListener('abort', () => {
            reject(new Error('Upload aborted'))
        })

        xhr.open(method, url, true)

        if (signal) {
            signal.addEventListener('abort', () => xhr.abort())
        }

        // Set Content-Type manually only for PUT
        if (isPut && file.type) {
            xhr.setRequestHeader('Content-Type', file.type)
        }

        xhr.send(dataToSend)
    })
}
